<div class="blade-wrapper">
    <div class="blade-header" *ngIf="!showInDialog || (showInDialog && hasToolbar)">
      <div *ngIf="!$hasMissingRequiredInParams"
          class="blade-tools">
          <app-toolbar [toolbar]="toolbar">
              <ng-template 
                toolbarToolDef="edit" let-tool>
                <ng-container  *ngIf="tool.hasButtonsToShow">
                <button mat-button
                        data-cy="button"
                        class="datex-button"
                        [disabled]="tool.control.readOnly"
                        [ngStyle]="tool.control.styles.style"
                        [ngClass]="tool.control.styles.classes"
                        [matTooltip]="tool.control.tooltip"
                        matTooltipClass="datex-control-tooltip"
                        (click)="on_edit_clicked($event)"
                        >
                  <div class="button-label">
                    <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                      <div class="button-icon">
                        <i data-cy="button-icon" class="datex-default-spinner"></i>
                      </div>
                    </ng-container>
                    <ng-template #showIcon>
                      <div class="button-icon">
                        <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                      </div>
                    </ng-template>
                    <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                  </div>
                
                </button>
                </ng-container>
              </ng-template>
          </app-toolbar>
      </div>
      <ng-content></ng-content>
    </div>

  <div class="blade-content">
    <div class="datex-hub">
      <ng-container
                    *ngIf="initialized && !$hasMissingRequiredInParams">
        <div class="hubdata">
          <h1 class="hubname" *ngIf="!showInDialog">{{hubTitle}}</h1>
          <h6 class="hubdesc">{{hubDescription}}</h6>
        </div>

        <div class="widgets">
          <div *ngIf="!widgets.serialnumber_net_weight_widget.hidden && !widgets.serialnumber_net_weight_widget.removed" class="widget-container">
            <Inventory-serialnumber_net_weight_widget
            #$widgets_serialnumber_net_weight_widget 
              [serialnumberId]="$widgets_serialnumber_net_weight_widget_inParams_serialnumberId"
            ($refreshEvent)="refresh(false, false, '$widgets_serialnumber_net_weight_widget')"
            >
            </Inventory-serialnumber_net_weight_widget>
          </div>
          <div *ngIf="!widgets.serialnumber_gross_weight_widget.hidden && !widgets.serialnumber_gross_weight_widget.removed" class="widget-container">
            <Inventory-serialnumber_gross_weight_widget
            #$widgets_serialnumber_gross_weight_widget 
              [serialnumberId]="$widgets_serialnumber_gross_weight_widget_inParams_serialnumberId"
            ($refreshEvent)="refresh(false, false, '$widgets_serialnumber_gross_weight_widget')"
            >
            </Inventory-serialnumber_gross_weight_widget>
          </div>
        </div>

        <div class="datex-tabcontrol" *ngIf="!this.rootTabGroup.allTabsHidden">
          <div class="tab-container">
            <div *ngIf="tabs.tasks.hasTabToShow" class="tab" data-cy="tab-tasks">
              <h2 [className]="tabs.tasks.active? 'active': ''" (click)="tabs.tasks.activate()">{{tabs.tasks.title}}</h2>
            </div>
          </div>
        
              <FootPrintPortalManager-inventory_tasks_grid *ngIf="tabs.tasks.active"
              #$tabs_tasks
              [serialnumberId]="$tabs_tasks_inventory_tasks_grid_inParams_serialnumberId"
              ($refreshEvent)="refresh(false, false, '$tabs_tasks')">
              </FootPrintPortalManager-inventory_tasks_grid>
        </div>

      </ng-container>
      <div *ngIf="$hasMissingRequiredInParams"
           class="missing-params">
        <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
      </div>
    </div>
  </div>
</div>